// @ts-nocheck
class ColorVariants extends HTMLElement {
    constructor() {
        super();

        window.colorVariantSwitching = false;
        this.lastSwatchByCategory = {};
        this.#ensureDelegatedListeners();
        this.init();
    }

    init() {
        this.colorVariants = this.querySelectorAll('.color-variant-single');
        // Use new media gallery structure
        this.mediaGallery = document.querySelector('.media-gallery__grid');
        console.log('[ColorVariants] init', {
            variantsFound: this.colorVariants ? this.colorVariants.length : 0,
            mediaGalleryFound: !!this.mediaGallery
        });
        this.setupEventListeners();
        this.setupCategoryTabs();
        this.initializeColorLabels();
        this.addPrefetchListeners();
        this.setupVariantPickerListener();
    }

    initializeStockAvailability() {
        console.log('[ColorVariants] Stock availability will be updated on variant change');
    }

    setupVariantPickerListener() {
        const variantPicker = document.querySelector('variant-picker');
        if (variantPicker) {
            variantPicker.addEventListener('change', (e) => {
                const variantIdInput = document.querySelector('input[name="id"]');
                if (variantIdInput) {
                    const variantId = parseInt(variantIdInput.value);
                    this.updateStockFromVariantId(variantId);
                }
            });
        }
    }

    setupCategoryTabs() {
        const tabs = this.querySelectorAll('.color-category-tab');
        if (!tabs.length) return;

        const activeTab = this.querySelector('.color-category-tab.active');
        if (activeTab?.dataset?.tabTarget) {
            this.updateFinalSaleNoticeByCategory(activeTab.dataset.tabTarget);
        }

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const targetCategory = tab.dataset.tabTarget;
                if (!targetCategory) return;

                this.switchToTab(targetCategory);
                this.selectSwatchForCategory(targetCategory);
            });
        });
    }

    getCategoryFromProductData(productData) {
        const tags = Array.isArray(productData?.tags) ? productData.tags : [];
        if (tags.includes('last-chance-color')) return 'last-chance';
        if (tags.includes('seasonal-color')) return 'seasonal';
        return 'core';
    }

    selectSwatchForCategory(category) {
        const panel = this.querySelector(`.color-tab-panel[data-tab-panel="${category}"]`);
        if (!panel) return;

        const remembered = this.lastSwatchByCategory[category];
        const swatch = remembered && panel.contains(remembered)
            ? remembered
            : panel.querySelector('.color-variant-single');

        if (!swatch) return;

        if (swatch.classList.contains('active') && swatch.dataset.productJson) {
            try {
                this.updateFinalSaleNotice(JSON.parse(swatch.dataset.productJson));
            } catch (error) {
                console.warn('[ColorVariants] Failed to update final sale notice on tab change', error);
            }
            return;
        }

        this.handleVariantClick(swatch);
    }

    async updateStockFromVariantId(variantId) {
        const stockElement = document.querySelector('.stock-availability');
        if (!stockElement) return;

        try {
            // Get threshold from data attribute - use a high default (1000) if not set
            const threshold = parseInt(stockElement.dataset.threshold) || 1000;

            // Get product URL from variant picker
            const variantPicker = document.querySelector('variant-picker');
            const productUrl = variantPicker?.dataset?.productUrl;
            if (!productUrl) return;

            // Fetch variant data
            const response = await fetch(`${productUrl}?view=variant&variant_id=${variantId}`);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const variantScript = doc.querySelector('script[type="application/json"]');

            if (variantScript) {
                const variant = JSON.parse(variantScript.textContent);
                const inventoryQuantity = variant.inventory_quantity || 0;
                const inventoryManagement = variant.inventory_management;

                console.log('[ColorVariants] Stock update:', {
                    variantId,
                    inventoryQuantity,
                    inventoryManagement,
                    threshold,
                    shouldShow: inventoryManagement === 'shopify' && inventoryQuantity > 0 && inventoryQuantity <= threshold
                });

                if (inventoryManagement === 'shopify' && inventoryQuantity > 0 && inventoryQuantity <= threshold) {
                    stockElement.style.display = 'flex';
                    stockElement.setAttribute('data-stock', inventoryQuantity);
                    const countElement = stockElement.querySelector('strong');
                    if (countElement) {
                        countElement.textContent = inventoryQuantity;
                    }
                } else {
                    stockElement.style.display = 'none';
                }
            }
        } catch (error) {
            console.warn('[ColorVariants] Failed to update stock availability', error);
        }
    }

    #ensureDelegatedListeners() {
        if (window.__colorVariantsDelegated) return;
        const delegate = (event) => {
            const target = event.target instanceof Element ? event.target : null;
            if (!target) return;
            const swatch = target.closest('.color-variant-single');
            if (!swatch) return;
            const host = swatch.closest('color-variants');
            if (!(host instanceof ColorVariants)) return;
            event.preventDefault();
            host.handleVariantClick(swatch);
        };
        document.addEventListener('touchend', delegate, { passive: false, capture: true });
        document.addEventListener('click', delegate, { capture: true });
        window.__colorVariantsDelegated = true;
    }

    initializeColorLabels() {
        console.log('[ColorVariants] initializeColorLabels called');

        // Find the currently active variant
        const activeVariant = this.querySelector('.color-variant-single.active');
        if (activeVariant && activeVariant.dataset.productJson) {
            try {
                const productData = JSON.parse(activeVariant.dataset.productJson);
                console.log('[ColorVariants] Found active variant, initializing color labels', productData);
                this.lastSwatchByCategory[this.getCategoryFromProductData(productData)] = activeVariant;
                this.updateColorDisplayLabels(productData);
                this.updateFinalSaleNotice(productData);
            } catch (error) {
                console.error('[ColorVariants] Error parsing active variant product data:', error);
            }
        } else {
            console.warn('[ColorVariants] No active variant found for initialization');
        }
    }

    setupEventListeners() {
        if (!this.colorVariants || this.colorVariants.length === 0) {
            console.warn('[ColorVariants] No .color-variant-single elements found');
            return;
        }
        this.colorVariants.forEach(variant => {
            variant.addEventListener('click', (e) => {
                console.log('[ColorVariants] Variant clicked', {
                    target: e.target,
                    currentTarget: e.currentTarget,
                    dataset: variant.dataset
                });
                this.handleVariantClick(e.currentTarget);
            });
        });
    }

    handleVariantClick(clickedVariant) {
        try {
            console.log('[ColorVariants] handleVariantClick start', clickedVariant);
            this.colorVariants.forEach(variant => {
                variant.classList.remove('active');
                if (variant instanceof HTMLElement) {
                    variant.removeAttribute('aria-current');
                }
            });

            clickedVariant.classList.add('active');
            if (clickedVariant instanceof HTMLElement) {
                clickedVariant.setAttribute('aria-current', 'true');
            }

            const productDataString = clickedVariant.dataset.productJson;
            if (!productDataString) {
                console.warn('[ColorVariants] No product JSON on clicked variant');
                return;
            }

            const productData = JSON.parse(productDataString);
            this.lastSwatchByCategory[this.getCategoryFromProductData(productData)] = clickedVariant;
            const preferredSelections = this.getCurrentNonColorSelections();
            const preferredVariant = this.getPreferredVariantForProduct(productData, preferredSelections);
            const preferredGalleryKey = this.getVariantSelectionKey(preferredVariant);
            const preferredHasVariantGallery = Array.isArray(preferredVariant?.variant_image_gallery) && preferredVariant.variant_image_gallery.length > 0;
            console.log('[ColorVariants] Parsed product data', {
                id: productData?.id,
                title: productData?.title,
                mediaCount: productData?.media?.length,
                preferredVariantId: preferredVariant?.id,
                preferredHasVariantGallery
            });


            window.colorVariantSwitching = true;
            console.log('[ColorVariants] colorVariantSwitching -> true');

            // Paint the main image first. Do not wait for section HTML or the rest of the gallery.
            this.updateMainImageImmediate(productData, preferredVariant);

            if (preferredHasVariantGallery && typeof window.__setMediaGalleryPending === 'function') {
                window.__setMediaGalleryPending(preferredGalleryKey);
            } else if (typeof window.__setMediaGalleryPending === 'function') {
                window.__setMediaGalleryPending(null);
            }

            // Remaining gallery images after the main image request has started.
            requestAnimationFrame(() => {
                // Variant-specific galleries come from the section render; swapping default
                // product media here would flash the wrong images.
                if (!preferredHasVariantGallery) {
                    this.updateMediaGallery(productData, { skipMain: true });
                }
            });
            this.updateBasicProductInfo(productData);
            this.updateProductBadge(productData);
            this.updateStockAvailability(productData);
            this.updateBuyButtonsAvailability(productData, preferredSelections);
            this.updateBackInStockDialog(productData, preferredSelections);
            this.updateVariantPickerDataset(productData, preferredSelections);
            this.syncNonColorOptionsToVariant(productData, preferredVariant);
            this.updateReviewsInfo(productData);
            this.updateUpsellSliders(productData);
            this.updateColorDisplayLabels(productData);
            this.updateFinalSaleNotice(productData);
            this.hideVariantSelectorTemporarily();
            this.updateVariantSelector(productData, preferredSelections);
            // Zoom dialog images compete with the main PDP image — wait until the browser is idle.
            if (!preferredHasVariantGallery) {
                this.scheduleIdle(() => this.updateModalContent(productData), 600);
            }
            // Update basic page info once
            this.updatePageInfo(productData, preferredSelections);
            // Finish
            window.colorVariantSwitching = false;
            console.log('[ColorVariants] colorVariantSwitching -> false');
            const variantSelector = document.querySelector('variant-selector');
            if (variantSelector) {
                this.clickFirstVariant(variantSelector, productData, preferredSelections);
            }

        } catch (error) {
            console.error('Error handling color variant click:', error);
            window.colorVariantSwitching = false;
            console.log('[ColorVariants] colorVariantSwitching -> false (error)');
        }
    }

    updateVariantPickerDataset(productData, preferredSelections = {}) {
        const picker = document.querySelector('variant-picker');
        if (!picker || !productData) return;
        try {
            const url = productData.url?.split('?')[0] || '';
            const id = String(productData.id || '');
            const preferredVariant = this.getPreferredVariantForProduct(productData, preferredSelections);
            const requestUrl = preferredVariant?.id ? `${url}?variant=${preferredVariant.id}` : url;
            if (url) {
                picker.dataset.productUrl = url;
                picker.setAttribute('data-product-url', url);
            }
            if (id) {
                picker.dataset.productId = id;
                picker.setAttribute('data-product-id', id);
            }
            if (typeof picker.setStickySelection === 'function') {
                Object.entries(preferredSelections || {}).forEach(([optionName, optionValue]) => {
                    if (picker.isStickyOption && picker.isStickyOption(optionName)) {
                        picker.setStickySelection(optionName, optionValue);
                    }
                });
            }
            if (requestUrl && typeof picker.fetchUpdatedSection === 'function') {
                picker.fetchUpdatedSection(requestUrl);
            }
        } catch(e) {}
    }

    syncNonColorOptionsToVariant(productData, variant) {
        // Checks the target size/inseam on the current picker so it does not flash the old
        // selection while updateVariantPickerDataset fetches the new color. No change event:
        // these inputs still carry the previous color's variant ids, and dispatching would abort
        // that fetch and request a variant the new product does not have, which Shopify answers
        // with its first available variant.
        const picker = document.querySelector('variant-picker');
        if (!picker || !variant) return;

        for (const option of productData.options || []) {
            const optionName = String(option?.name || '').toLowerCase();
            if (!optionName || optionName.includes('color')) continue;

            const optionElement = Array.from(picker.querySelectorAll('.variant-option')).find((element) => {
                return element.getAttribute('data-option-name')?.toLowerCase() === optionName;
            });
            if (!optionElement) continue;

            const value = String(variant[`option${option.position}`] || '');
            const radio = Array.from(optionElement.querySelectorAll('input[type="radio"]')).find((input) => input.value === value);
            if (radio) {
                radio.checked = true;
                continue;
            }

            const select = optionElement.querySelector('select');
            if (select && Array.from(select.options).some((selectOption) => selectOption.value === value)) {
                select.value = value;
            }
        }
    }

    scheduleIdle(callback, timeout = 400) {
        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(callback, { timeout });
            return;
        }
        setTimeout(callback, timeout);
    }

    getViewportImageWidth(isMain = true) {
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const cssWidth = isMobile
            ? window.innerWidth
            : isMain
                ? Math.min(window.innerWidth * 0.6, 1200)
                : Math.min(window.innerWidth * 0.4, 750);
        const px = Math.ceil(cssWidth * dpr);
        const widths = [450, 600, 750, 832, 900, 1050, 1200, 1350, 1500, 1800, 1946];
        return widths.find((width) => width >= px) || 1946;
    }

    getShopifyImageSrc(url, width) {
        if (!url) return '';
        const baseSrc = String(url).split('?')[0];
        return `${baseSrc}?width=${width}`;
    }

    getMainImageUrl(productData, preferredVariant) {
        const gallery = preferredVariant?.variant_image_gallery;
        if (Array.isArray(gallery) && gallery[0]) return gallery[0];
        const firstMedia = productData?.media?.[0];
        return firstMedia?.preview_image?.src || firstMedia?.src || '';
    }

    getPrimaryMainImages() {
        const gallery = document.querySelector('media-gallery');
        if (!gallery) return [];

        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        if (isMobile) {
            const slideImg =
                gallery.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image') ||
                gallery.querySelector('slideshow-slides slideshow-slide img.product-media__image') ||
                gallery.querySelector('slideshow-component img.product-media__image');
            return slideImg ? [slideImg] : [];
        }

        const gridImg = gallery.querySelector(
            '.media-gallery__grid .product-media-container--image img.product-media__image, .media-gallery__grid img.product-media__image'
        );
        return gridImg ? [gridImg] : [];
    }

    demoteNonMainGalleryImages(mainImages) {
        const mains = new Set(mainImages);
        document.querySelectorAll('media-gallery img').forEach((img) => {
            if (mains.has(img)) return;
            img.setAttribute('fetchpriority', 'low');
            img.fetchPriority = 'low';
            if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
        });
    }

    applyMainImageToElement(img, imageUrl, width, { priority = 'high' } = {}) {
        const displaySrc = this.getShopifyImageSrc(imageUrl, width);
        img.setAttribute('loading', priority === 'high' ? 'eager' : 'lazy');
        img.setAttribute('fetchpriority', priority);
        img.fetchPriority = priority;
        img.decoding = 'async';
        img.removeAttribute('srcset');
        img.src = displaySrc;
        if (!img.getAttribute('sizes')) img.setAttribute('sizes', '100vw');
    }

    updateMainImageImmediate(productData, preferredVariant) {
        const imageUrl = this.getMainImageUrl(productData, preferredVariant);
        if (!imageUrl) return;

        this.mainImageRequestId = (this.mainImageRequestId || 0) + 1;
        const requestId = this.mainImageRequestId;
        const width = this.getViewportImageWidth(true);
        const displaySrc = this.getShopifyImageSrc(imageUrl, width);

        const slideshow = document.querySelector('media-gallery slideshow-component');
        if (slideshow && typeof slideshow.select === 'function') {
            slideshow.select(0, null, { animate: false });
        }

        const mainImages = this.getPrimaryMainImages();
        this.demoteNonMainGalleryImages(mainImages);

        const preload = new Image();
        preload.fetchPriority = 'high';
        preload.decoding = 'async';
        preload.src = displaySrc;

        const apply = () => {
            if (requestId !== this.mainImageRequestId) return;
            this.getPrimaryMainImages().forEach((img) => this.applyMainImageToElement(img, imageUrl, width));

            // Only once the image the shopper is actually looking at has been requested (and the
            // rest of this viewport's own gallery is already underway via the rAF-deferred
            // updateMediaGallery call in handleVariantClick) do we quietly backfill the OTHER
            // layout's main-image slot too — desktop grid while on mobile, or vice versa. It's
            // deliberately last and low-priority: by the time it runs, nothing this switch's own
            // viewport actually needs is still waiting on it, so it costs the current view nothing.
            this.scheduleIdle(() => this.updateInactiveMainImage(imageUrl, requestId), 1500);
        };

        if (preload.complete) {
            apply();
        } else {
            preload.onload = apply;
        }
    }

    /**
     * Fills in the main-image slot for the layout that ISN'T active for the current viewport (the
     * desktop grid while the shopper is on mobile, or the mobile slideshow while they're on
     * desktop). updateMainImageImmediate() intentionally skips this slot in its fast path so a
     * color switch never fetches an image nobody's looking at; this runs afterward, at low
     * priority, so that if the shopper later resizes across the breakpoint (or rotates a tablet)
     * without a full page reload, that layout is already showing the right color instead of
     * whatever was selected before this switch — without adding any load to the viewport the
     * switch actually happened on.
     */
    updateInactiveMainImage(imageUrl, requestId) {
        if (requestId !== this.mainImageRequestId) return; // superseded by a newer switch meanwhile

        const gallery = document.querySelector('media-gallery');
        if (!gallery) return;

        const activeImages = new Set(this.getPrimaryMainImages());
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const inactiveImg = isMobile
            ? gallery.querySelector('.media-gallery__grid .product-media-container--image img.product-media__image, .media-gallery__grid img.product-media__image')
            : gallery.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image') ||
              gallery.querySelector('slideshow-slides slideshow-slide img.product-media__image') ||
              gallery.querySelector('slideshow-component img.product-media__image');

        if (!(inactiveImg instanceof HTMLImageElement) || activeImages.has(inactiveImg)) return;

        const width = this.getViewportImageWidth(true);
        const expectedSrc = this.getShopifyImageSrc(imageUrl, width);
        if (inactiveImg.src === expectedSrc) return;

        this.applyMainImageToElement(inactiveImg, imageUrl, width, { priority: 'low' });
    }

    updateMediaGallery(productData, { skipMain = false } = {}) {
        console.log('[ColorVariants] updateMediaGallery called', {
            hasGallery: !!this.mediaGallery,
            hasMedia: !!productData?.media,
            mediaCount: productData?.media?.length || 0,
            skipMain
        });

        if (!productData?.media || productData.media.length === 0) {
            console.warn('[ColorVariants] No media in product data');
            return;
        }

        this.updateGridGallery(productData, { skipMain });
        this.updateSlideshowGallery(productData, { skipMain });

        console.log('[ColorVariants] updateMediaGallery completed');
    }

    async replaceMediaGalleryFromURL(url) {
        try {
            if (!url) return;
            const response = await fetch(url, { credentials: 'same-origin' });
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newGallery = doc.querySelector('media-gallery');
            const currentGallery = document.querySelector('media-gallery');
            if (newGallery && currentGallery && newGallery.outerHTML) {
                // Swap the entire custom element so its internal slideshow works identically on mobile
                currentGallery.replaceWith(newGallery);

                // Wait for the new custom element to be defined and connected
                // Custom elements need a moment to initialize
                await new Promise(resolve => {
                    // Check if custom element is already defined
                    if (customElements.get('media-gallery')) {
                        // Wait for next frame to ensure connectedCallback has run
                        requestAnimationFrame(() => {
                            requestAnimationFrame(resolve);
                        });
                    } else {
                        // Wait a bit longer if custom element isn't defined yet
                        setTimeout(resolve, 200);
                    }
                });
            }
        } catch (e) {
            console.warn('[ColorVariants] Failed to replace media-gallery from URL', e);
        }
    }


    updateGridGallery(productData, { skipMain = false } = {}) {
        if (!this.mediaGallery) {
            console.warn('[ColorVariants] .media-gallery__grid not found');
            return;
        }

        // Update main grid media items (first 4 images)
        const mainGridContainers = Array.from(document.querySelectorAll('.media-gallery__grid .product-media-container--image .product-media'));
        console.log('[ColorVariants] Found main grid media containers', mainGridContainers.length);

        mainGridContainers.forEach((container, index) => {
            if (skipMain && index === 0) return;
            const media = productData.media[index];
            const parentLi = container.closest('li.product-media-container');

            if (!media) {
                console.warn('[ColorVariants] No media for main grid container index', index, '- hiding container');
                if (parentLi) parentLi.style.visibility = 'hidden';
                return;
            }

            // Show the container if it was hidden
            if (parentLi) parentLi.style.visibility = '';

            this.updateMediaContainer(container, media, index, { isMain: index === 0 });
        });

        // Update sidebar media items (images beyond first 4)
        const sidebarContainers = Array.from(document.querySelectorAll('.media-gallery__sidebar-list .product-media-container--image .product-media'));
        console.log('[ColorVariants] Found sidebar media containers', sidebarContainers.length);

        sidebarContainers.forEach((container, index) => {
            // Sidebar images start from index 4 (after the first 4 main grid images)
            const mediaIndex = index + 4;
            const media = productData.media[mediaIndex];
            const parentLi = container.closest('li.product-media-container');

            if (!media) {
                console.warn('[ColorVariants] No media for sidebar container index', mediaIndex, '- hiding container');
                if (parentLi) parentLi.style.visibility = 'hidden';
                return;
            }

            // Show the container if it was hidden
            if (parentLi) parentLi.style.visibility = '';

            this.updateMediaContainer(container, media, mediaIndex, { isMain: false });
        });
    }

    updateMediaContainer(container, media, index, { isMain = false } = {}) {
        container.setAttribute('data-media-id', media.id);

        if (media.media_type === 'image') {
            let img = container.querySelector('img.product-media__image, img');
            // Remove any existing video
            const existingVideo = container.querySelector('video');
            if (existingVideo) existingVideo.remove();

            if (!img) {
                img = document.createElement('img');
                img.className = 'product-media__image';
                container.appendChild(img);
            }

            const baseSrc = (media.preview_image?.src || media.src || '').split('?')[0];
            const displayWidth = this.getViewportImageWidth(isMain);
            const candidateWidths = isMain
                ? [displayWidth, Math.min(displayWidth + 300, 1946)]
                : [450, 600, 750, displayWidth];
            const nextSrcset = candidateWidths
                .filter((v, i, a) => !!v && a.indexOf(v) === i)
                .sort((a, b) => a - b)
                .map((w) => `${baseSrc}?width=${w} ${w}w`)
                .join(', ');
            const displaySrc = `${baseSrc}?width=${displayWidth}`;

            img.alt = media.alt || '';
            img.decoding = 'async';
            img.setAttribute('loading', isMain ? 'eager' : 'lazy');
            img.setAttribute('fetchpriority', isMain ? 'high' : 'low');
            img.fetchPriority = isMain ? 'high' : 'low';
            img.setAttribute('data-media-id', media.id);
            img.setAttribute('width', media.width || img.getAttribute('width') || '');
            img.setAttribute('height', media.height || img.getAttribute('height') || '');

            if (isMain) {
                if (img.src !== displaySrc) {
                    const preload = new Image();
                    preload.fetchPriority = 'high';
                    preload.decoding = 'async';
                    preload.src = displaySrc;
                    preload.onload = () => {
                        img.setAttribute('srcset', nextSrcset);
                        if (!img.getAttribute('sizes')) img.setAttribute('sizes', '100vw');
                        img.src = displaySrc;
                    };
                } else {
                    img.setAttribute('srcset', nextSrcset);
                    if (!img.getAttribute('sizes')) img.setAttribute('sizes', '100vw');
                    img.src = displaySrc;
                }
            } else {
                img.setAttribute('srcset', nextSrcset);
                if (!img.getAttribute('sizes')) img.setAttribute('sizes', '100vw');
                img.src = displaySrc;
            }

            // Update zoom button index if present
            const parentLi = container.closest('li.product-media-container');
            const zoomBtn = parentLi ? parentLi.querySelector('.product-media-container__zoom-button') : null;
            if (zoomBtn && zoomBtn.hasAttribute('on:click')) {
                zoomBtn.setAttribute('on:click', `/zoom/${index}`);
            }

        } else if (media.media_type === 'video') {
            // Replace content with video
            container.innerHTML = '';
            const video = document.createElement('video');
            video.src = media.sources?.[0]?.url || media.src || '';
            video.controls = true;
            video.autoplay = true;
            video.setAttribute('autoplay', 'autoplay');
            video.setAttribute('playsinline', 'true');
            video.loop = true;
            video.preload = 'none';
            video.style.width = '100%';
            video.style.height = 'auto';
            video.setAttribute('data-media-id', media.id);
            container.appendChild(video);
        }
    }

    updateSlideshowGallery(productData, { skipMain = false } = {}) {
        // Find slideshow container - try multiple selectors to be robust
        let slideshowContainer = document.querySelector('media-gallery slideshow-slides');
        if (!slideshowContainer) {
            slideshowContainer = document.querySelector('slideshow-slides');
        }

        if (!slideshowContainer) {
            console.log('[ColorVariants] No slideshow container found - slideshow may not be present or not yet initialized');
            // Retry after a short delay in case slideshow is still initializing
            setTimeout(() => {
                const retryContainer = document.querySelector('media-gallery slideshow-slides') ||
                                      document.querySelector('slideshow-slides');
                if (retryContainer && productData?.media?.length > 0) {
                    console.log('[ColorVariants] Retrying slideshow update after delay');
                    this.updateSlideshowGallery(productData);
                }
            }, 200);
            return;
        }

        console.log('[ColorVariants] Updating slideshow gallery', {
            slidesFound: slideshowContainer.querySelectorAll('slideshow-slide').length,
            mediaCount: productData?.media?.length || 0
        });

        // Find all slideshow slides
        const slides = Array.from(slideshowContainer.querySelectorAll('slideshow-slide'));
        console.log('[ColorVariants] Found slideshow slides', slides.length);

        if (slides.length === 0) {
            console.warn('[ColorVariants] No slides found in slideshow container');
            return;
        }

        slides.forEach((slide, index) => {
            if (skipMain && index === 0) return;
            const media = productData.media[index];
            if (!media) {
                // Hide extra slides if new product has fewer images
                console.log('[ColorVariants] No media for slide index', index, '- hiding slide');
                slide.style.display = 'none';
                return;
            }

            // Show slide if it was hidden
            slide.style.display = '';

            // Find the product media container within the slide
            const mediaContainer = slide.querySelector('.product-media-container .product-media');
            if (!mediaContainer) {
                console.warn('[ColorVariants] No media container in slide', index);
                return;
            }

            // Update the media container with new media
            this.updateSlideMedia(mediaContainer, media, index, { isMain: index === 0 });

            // Update zoom functionality for the slide
            const zoomTrigger = slide.querySelector('[on\\:click*="zoom-dialog"]');
            if (zoomTrigger) {
                const currentOnClick = zoomTrigger.getAttribute('on:click');
                if (currentOnClick && currentOnClick.includes('/open/')) {
                    zoomTrigger.setAttribute('on:click', currentOnClick.replace(/\/open\/\d+/, `/open/${index}`));
                }
            }
        });

        // Force slideshow to refresh/reinitialize
        this.reinitializeSlideshow(slideshowContainer);
    }

    updateSlideMedia(container, media, index, { isMain = false } = {}) {
        container.setAttribute('data-media-id', media.id);

        if (media.media_type === 'image') {
            let img = container.querySelector('img.product-media__image, img');
            // Remove any existing video
            const existingVideo = container.querySelector('video');
            if (existingVideo) existingVideo.remove();

            if (!img) {
                img = document.createElement('img');
                img.className = 'product-media__image';
                container.appendChild(img);
            }

            const baseSrc = (media.preview_image?.src || media.src || '').split('?')[0];
            const displayWidth = this.getViewportImageWidth(isMain);
            const candidateWidths = isMain
                ? [displayWidth, Math.min(displayWidth + 300, 1946)]
                : [450, 600, 750, displayWidth];
            const nextSrcset = candidateWidths
                .filter((v, i, a) => !!v && a.indexOf(v) === i)
                .sort((a, b) => a - b)
                .map((w) => `${baseSrc}?width=${w} ${w}w`)
                .join(', ');
            const displaySrc = `${baseSrc}?width=${displayWidth}`;

            img.alt = media.alt || '';
            img.decoding = 'async';
            img.setAttribute('loading', isMain ? 'eager' : 'lazy');
            img.setAttribute('fetchpriority', isMain ? 'high' : 'low');
            img.fetchPriority = isMain ? 'high' : 'low';
            img.setAttribute('data-media-id', media.id);
            img.setAttribute('width', media.width || img.getAttribute('width') || '');
            img.setAttribute('height', media.height || img.getAttribute('height') || '');

            if (isMain) {
                if (img.src !== displaySrc) {
                    const preload = new Image();
                    preload.fetchPriority = 'high';
                    preload.decoding = 'async';
                    preload.src = displaySrc;
                    preload.onload = () => {
                        img.setAttribute('srcset', nextSrcset);
                        if (!img.getAttribute('sizes')) img.setAttribute('sizes', '100vw');
                        img.src = displaySrc;
                    };
                } else {
                    img.setAttribute('srcset', nextSrcset);
                    if (!img.getAttribute('sizes')) img.setAttribute('sizes', '100vw');
                    img.src = displaySrc;
                }
            } else {
                img.setAttribute('srcset', nextSrcset);
                if (!img.getAttribute('sizes')) img.setAttribute('sizes', '100vw');
                img.src = displaySrc;
            }

        } else if (media.media_type === 'video') {
            // Replace content with video
            container.innerHTML = '';
            const video = document.createElement('video');
            video.src = media.sources?.[0]?.url || media.src || '';
            video.controls = true;
            video.autoplay = true;
            video.setAttribute('playsinline', 'true');
            video.loop = true;
            video.preload = 'none';
            video.style.width = '100%';
            video.style.height = 'auto';
            video.setAttribute('data-media-id', media.id);
            container.appendChild(video);
        }
    }

    addPrefetchListeners() {
        if (!this.colorVariants || this.colorVariants.length === 0) return;

        const prefetchVariant = (variant) => {
            if (!variant || variant.__prefetched) return;
            const json = variant.dataset.productJson;
            if (!json) return;
            try {
                const data = JSON.parse(json);
                const firstVariantWithGallery = (data.variants || []).find((variant) => {
                    return Array.isArray(variant.variant_image_gallery) && variant.variant_image_gallery[0];
                });
                const firstMedia = data?.media?.[0];
                const imgUrl =
                    firstVariantWithGallery?.variant_image_gallery[0] ||
                    firstMedia?.preview_image?.src ||
                    firstMedia?.src;
                if (imgUrl) {
                    const baseSrc = imgUrl.split('?')[0];
                    const width = this.getViewportImageWidth(true);
                    const href = `${baseSrc}?width=${width}`;
                    const link = document.createElement('link');
                    link.rel = 'preload';
                    link.as = 'image';
                    link.href = href;
                    link.fetchPriority = 'high';
                    document.head.appendChild(link);
                    const img = new Image();
                    img.decoding = 'async';
                    img.fetchPriority = 'high';
                    img.src = href;
                }
                if (data?.url) {
                    const navPrefetch = document.createElement('link');
                    navPrefetch.rel = 'prefetch';
                    navPrefetch.href = data.url;
                    document.head.appendChild(navPrefetch);
                }
                variant.__prefetched = true;
            } catch (e) {}
        };

        this.colorVariants.forEach((variant) => {
            variant.addEventListener('pointerenter', () => prefetchVariant(variant), { once: true });
            variant.addEventListener('touchstart', () => prefetchVariant(variant), { once: true, passive: true });
        });
    }

    reinitializeSlideshow(slideshowContainer) {
        // Find the parent slideshow component
        const slideshowComponent = slideshowContainer.closest('slideshow-component');
        if (!slideshowComponent) {
            console.warn('[ColorVariants] No slideshow component found');
            return;
        }

        console.log('[ColorVariants] Reinitializing slideshow');

        // Try to trigger slideshow refresh
        try {
            // Force slideshow to re-scan for slides
            if (typeof slideshowComponent.connectedCallback === 'function') {
                slideshowComponent.disconnectedCallback?.();
                slideshowComponent.connectedCallback();
                console.log('[ColorVariants] Slideshow component reinitialized');
            }

            // Also try to select the first slide to ensure proper display
            setTimeout(() => {
                if (typeof slideshowComponent.select === 'function') {
                    slideshowComponent.select(0, null, { animate: false });
                    console.log('[ColorVariants] Selected first slide');
                }
            }, 100);

        } catch (error) {
            console.warn('[ColorVariants] Error reinitializing slideshow:', error);
        }
    }

    createSlide(media, index) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.setAttribute('data-media-id', media.id);
        slide.setAttribute('data-media-index', index);


        const originalZoomTrigger = this.mediaGallery?.querySelector('.light-box-zoom-trigger');
        const originalZoomIcon = this.mediaGallery?.querySelector('.product__media-icon');
        const isZoomEnabled = originalZoomTrigger || originalZoomIcon;
        const isHoverZoom = this.mediaGallery?.querySelector('.hover-zoom-enabled') !== null;


        if (isHoverZoom) {
            const loadingSpinner = document.createElement('div');
            loadingSpinner.className = 'loading__spinner hidden';
            loadingSpinner.innerHTML = '{{ "icon-loading-spinner.svg" | inline_asset_content }}';
            slide.appendChild(loadingSpinner);
        }

        const productMedia = document.createElement('div');
        productMedia.className = 'product-media';


        if (isZoomEnabled) {
            const zoomTrigger = document.createElement('div');
            zoomTrigger.className = 'light-box-zoom-trigger';
            if (isHoverZoom) {
                zoomTrigger.classList.add('hover-zoom-enabled');
            }
            zoomTrigger.setAttribute('data-media-id', media.id);
            zoomTrigger.setAttribute('data-modal', '#ProductModal-' + (this.getSectionId() || ''));
            zoomTrigger.innerHTML = '&nbsp;';
            productMedia.appendChild(zoomTrigger);
        }

        this.createMediaElement(media, productMedia);
        slide.appendChild(productMedia);
        return slide;
    }

    createMediaElement(media, container) {
        if (media.media_type === 'image') {
            const img = document.createElement('img');
            img.src = media.src;
            img.alt = media.alt || '';
            img.loading = 'lazy';
            img.style.width = '100%';
            img.style.height = 'auto';
            img.className = 'image-magnify-hover';
            img.setAttribute('data-media-id', media.id);
            container.appendChild(img);
        } else if (media.media_type === 'video') {
            const video = document.createElement('video');
            video.src = media.sources?.[0]?.url || media.src;
            video.controls = true;
            video.autoplay = true;
            video.setAttribute('playsinline', true);
            video.loop = true;
            video.preload = 'none';
            video.style.width = '100%';
            video.style.height = 'auto';
            video.setAttribute('data-media-id', media.id);
            container.appendChild(video);
        } else {
            const img = document.createElement('img');
            img.src = media.preview_image?.src || media.src;
            img.alt = media.alt || '';
            img.loading = 'lazy';
            img.style.width = '100%';
            img.style.height = 'auto';
            container.appendChild(img);
        }
    }

    getSectionId() {
        const productInfo = document.querySelector('product-info');
        return productInfo?.getAttribute('data-section') || '';
    }

    createThumbnail(media, index) {
        const thumbnail = document.createElement('div');
        thumbnail.className = 'thumbnail-item';
        thumbnail.setAttribute('data-media-index', index);

        const img = document.createElement('img');
        let imageUrl = media.preview_image?.src || media.src;
        if (imageUrl && !imageUrl.includes('_100x')) {
            imageUrl = imageUrl.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_100x100.$1');
        }

        img.src = imageUrl;
        img.alt = media.alt || '';
        img.width = 100;
        img.height = 100;
        img.loading = 'lazy';

        thumbnail.appendChild(img);
        return thumbnail;
    }

    updateBasicProductInfo(productData) {
        // Update product title - look for multiple possible selectors
        const titleSelectors = [
            '.product-title-text h1', // Specific title text block (real markup renders an h1, not a p)
            '.product-title-text p',
            '.group--title-price h1', // Title inside title-price group
            '.group--title-price .text-block p',
            '[data-display-title]', // From your reference code
            '.product-details h1',
            'h1'
        ];

        let titleElement = null;
        for (const selector of titleSelectors) {
            titleElement = document.querySelector(selector);
            if (titleElement) {
                console.log('[ColorVariants] Found title element with selector:', selector);
                break;
            }
        }

        // Get combined listing title from color-variants data attribute
        const colorVariantsElement = document.querySelector('color-variants[data-combined-title]');
        const combinedTitle = colorVariantsElement?.dataset.combinedTitle;

        // Use combined listing title if available, otherwise use product title
        const displayTitle = combinedTitle || productData.title;

        if (titleElement) {
            titleElement.textContent = displayTitle;
            console.log('[ColorVariants] Updated title to:', displayTitle, '(from combined listing:', !!combinedTitle, ')');
        } else {
            console.warn('[ColorVariants] No title element found with any selector');
        }

        // Update breadcrumb current-page label (snippets/breadcrumbs.liquid renders
        // {{ product.title }} server-side; it never re-renders on a client-side color
        // switch, so it goes stale until a full page reload without this).
        const breadcrumbSelectors = [
            'nav[aria-label="breadcrumb"] .breadcrumb-item--current .breadcrumb-current',
            'nav[aria-label="breadcrumb"] .breadcrumb-current',
            '.breadcrumb-current'
        ];

        let breadcrumbElement = null;
        for (const selector of breadcrumbSelectors) {
            breadcrumbElement = document.querySelector(selector);
            if (breadcrumbElement) break;
        }

        if (breadcrumbElement) {
            breadcrumbElement.textContent = displayTitle;
            console.log('[ColorVariants] Updated breadcrumb to:', displayTitle);
        }

        // Update product description
        const descriptionElement = document.querySelector('.product__description p');
        if (descriptionElement) {
            descriptionElement.textContent = productData.description;
        }

        // Update product information with first variant
        const firstVariant = productData.variants[0];
        if (firstVariant) {
            this.updatePrice(firstVariant);
            this.updateSKU(firstVariant);
            this.updateInventory(firstVariant);
            this.updateAddToCartForm(firstVariant);
        }
    }

    updateStockAvailability(productData) {
        console.log('[ColorVariants] updateStockAvailability called');

        const stockElement = document.querySelector('.stock-availability');
        if (!stockElement) {
            console.log('[ColorVariants] No stock availability element found');
            return;
        }

        // Get threshold from data attribute or default to 1000
        const threshold = parseInt(stockElement.dataset.threshold) || 1000;

        // Get current selected variant (from variant picker or first available)
        const variantIdInput = document.querySelector('input[name="id"]');
        const currentVariantId = variantIdInput ? parseInt(variantIdInput.value) : null;

        // Find the variant in productData
        const currentVariant = productData.variants?.find(v => v.id === currentVariantId) ||
                              productData.selected_or_first_available_variant ||
                              productData.variants?.[0];

        if (!currentVariant) {
            console.log('[ColorVariants] No variant found for stock update - keeping current display');
            // Don't hide it if we can't find the variant - keep what Liquid rendered
            return;
        }

        const inventoryQuantity = currentVariant.inventory_quantity || 0;
        const inventoryManagement = currentVariant.inventory_management;

        console.log('[ColorVariants] Stock check:', {
            inventoryQuantity,
            inventoryManagement,
            threshold,
            shouldShow: inventoryManagement === 'shopify' && inventoryQuantity > 0 && inventoryQuantity <= threshold
        });

        // Show only if inventory is tracked, quantity > 0, and <= threshold
        if (inventoryManagement === 'shopify' && inventoryQuantity > 0 && inventoryQuantity <= threshold) {
            stockElement.style.display = 'flex';
            stockElement.setAttribute('data-stock', inventoryQuantity);

            // Update the count in the text
            const countElement = stockElement.querySelector('strong');
            if (countElement) {
                countElement.textContent = inventoryQuantity;
            }
        } else {
            // Only hide if we're certain it shouldn't show
            // If inventory is not tracked, keep it visible (Liquid already handled this)
            if (inventoryManagement === 'shopify') {
                stockElement.style.display = 'none';
            }
            // Otherwise, keep the display state from Liquid
        }
    }

    updateBuyButtonsAvailability(productData, preferredSelections = {}) {
        // Combined listing variants are separate products, so availability comes from the
        // variant we are about to select for this color. The `variant:update` event will
        // also correct this, but syncing here avoids a flash of the wrong button.
        if (typeof window.syncBuyButtonsAvailability !== 'function') return;

        const selectedVariant = this.getPreferredVariantForProduct(productData, preferredSelections);
        if (!selectedVariant) return;

        window.syncBuyButtonsAvailability(!!selectedVariant.available);
    }

    updateBackInStockDialog(productData, preferredSelections = {}) {
        // Combined listing colors are separate products, so the back-in-stock (Klaviyo) dialog
        // must be re-pointed at the newly selected product/variant. product-form.js bails out of
        // syncing the dialog when the product id changes without a reload, so we handle it here.
        const dialog = document.getElementById('back-in-stock-dialog') || document.querySelector('.back-in-stock-dialog');
        if (!dialog || !productData) return;

        const titleElement = dialog.querySelector('.back-in-stock-dialog__title');
        if (titleElement && productData.title) {
            titleElement.textContent = productData.title;
        }

        const bisForm = dialog.querySelector('klaviyo-back-in-stock-form');
        if (bisForm && productData.id) {
            bisForm.setAttribute('data-product', String(productData.id));
        }

        const select = dialog.querySelector('[data-variant-selector]');
        if (select && Array.isArray(productData.variants)) {
            const preferredVariant = this.getPreferredVariantForProduct(productData, preferredSelections);
            const selectedId = preferredVariant ? String(preferredVariant.id) : '';

            select.innerHTML = '';
            productData.variants.forEach((variant) => {
                const option = document.createElement('option');
                option.value = variant.id;
                option.textContent = variant.title;
                if (String(variant.id) === selectedId) {
                    option.selected = true;
                }
                select.appendChild(option);
            });

            if (productData.id) {
                select.id = `klaviyo-bis-variant-${productData.id}`;
            }
        }

        if (productData.id) {
            const emailInput = dialog.querySelector('[data-email-field]');
            const emailLabel = dialog.querySelector('label[for^="klaviyo-bis-email-"]');
            if (emailInput) {
                emailInput.id = `klaviyo-bis-email-${productData.id}`;
                if (emailLabel) emailLabel.setAttribute('for', emailInput.id);
            }

            const marketingInput = dialog.querySelector('[data-marketing-consent-field]');
            const marketingLabel = dialog.querySelector('label[for^="klaviyo-bis-marketing-"]');
            if (marketingInput) {
                marketingInput.id = `klaviyo-bis-marketing-${productData.id}`;
                if (marketingLabel) marketingLabel.setAttribute('for', marketingInput.id);
            }
        }
    }

    updateProductBadge(productData) {
        console.log('[ColorVariants] updateProductBadge called');

        // Find the badge element
        const badgeElement = document.querySelector('.product-info-badge');
        if (!badgeElement) {
            console.log('[ColorVariants] No badge element found');
            return;
        }

        // Get badge value from product metafields
        const badgeValue = productData.metafields?.custom?.product_info_badge?.value;

        if (badgeValue) {
            // Update badge text
            const badgeParagraph = badgeElement.querySelector('p');
            if (badgeParagraph) {
                badgeParagraph.textContent = badgeValue;
            } else {
                badgeElement.innerHTML = `<p>${badgeValue}</p>`;
            }
            // Show badge - explicitly remove inline display:none style
            badgeElement.style.removeProperty('display');
            console.log('[ColorVariants] Updated badge to:', badgeValue);
        } else {
            // Hide badge if no value
            badgeElement.style.display = 'none';
            console.log('[ColorVariants] Badge hidden (no value for this product)');
        }
    }

    updateColorDisplayLabels(productData) {
        console.log('[ColorVariants] updateColorDisplayLabels called', {
            productTitle: productData.title,
            productColor: productData.metafields?.custom?.color?.value
        });

        // Get the color name from the product metafield - try multiple structures
        let colorName = '';

        // Method 1: Check for array structure
        if (productData.metafields?.custom?.color?.value && Array.isArray(productData.metafields.custom.color.value) && productData.metafields.custom.color.value.length > 0) {
            colorName = productData.metafields.custom.color.value[0];
            console.log('[ColorVariants] Found color from array:', colorName);
        }
        // Method 2: Check for string structure
        else if (productData.metafields?.custom?.color?.value && typeof productData.metafields.custom.color.value === 'string') {
            colorName = productData.metafields.custom.color.value;
            console.log('[ColorVariants] Found color from string:', colorName);
        }
        // Method 3: Try to extract color from product tags (color:colorname format)
        else if (productData.tags && Array.isArray(productData.tags)) {
            const colorTag = productData.tags.find(tag => tag.startsWith('color:'));
            if (colorTag) {
                colorName = colorTag.replace('color:', '');
                console.log('[ColorVariants] Found color from tag:', colorName);
            }
        }

        // Clean up the color name
        if (colorName && typeof colorName === 'string') {
            colorName = colorName.trim().replace(/[-_]/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            console.log('[ColorVariants] Cleaned color name:', colorName);
        }

        // Determine current product category
        const tags = productData.tags || [];
        let currentCategory = 'core';
        if (tags.includes('seasonal-color')) currentCategory = 'seasonal';
        if (tags.includes('last-chance-color')) currentCategory = 'last-chance';

        // Update the unified color display label
        const unifiedSpan = document.querySelector('[data-display-color="unified"]');
        if (unifiedSpan) {
            unifiedSpan.textContent = colorName || '';
        }

        // Also update legacy per-category spans if they still exist
        const coreSpan = document.querySelector('[data-display-color="core"]');
        const seasonalSpan = document.querySelector('[data-display-color="seasonal"]');
        const lastChanceSpan = document.querySelector('[data-display-color="last-chance"]');

        if (coreSpan) coreSpan.textContent = (currentCategory === 'core' && colorName) ? colorName : '';
        if (seasonalSpan) seasonalSpan.textContent = (currentCategory === 'seasonal' && colorName) ? colorName : '';
        if (lastChanceSpan) lastChanceSpan.textContent = (currentCategory === 'last-chance' && colorName) ? colorName : '';

        // Switch to the correct tab when a swatch is clicked
        this.switchToTab(currentCategory);

        console.log('[ColorVariants] Updated color display:', currentCategory, colorName);
    }

    updateFinalSaleNotice(productData) {
        const finalSaleNotes = document.querySelectorAll(
            '[data-add-to-cart-block] .product-final-sale-notes, .sticky-add-to-cart .product-final-sale-notes'
        );
        if (!finalSaleNotes.length) return;

        const tags = Array.isArray(productData?.tags) ? productData.tags : [];
        const isLastChance = tags.includes('last-chance-color');
        this.updateFinalSaleNoticeByCategory(isLastChance ? 'last-chance' : 'core');
    }

    updateFinalSaleNoticeByCategory(category) {
        const noteWrappers = document.querySelectorAll('.product-final-sale-notes');
        const finalSaleNotes = document.querySelectorAll('.product-final-sale-note');
        if (!noteWrappers.length && !finalSaleNotes.length) return;
        const showFinalSaleNote = category === 'last-chance';

        // The wrapper's [hidden] gate is server-rendered for the initial product;
        // swatch/tab swaps happen without a section re-render, so it goes stale
        // unless toggled here too.
        noteWrappers.forEach((wrapper) => {
            wrapper.hidden = !showFinalSaleNote;
        });

        finalSaleNotes.forEach((note) => {
            if (showFinalSaleNote) {
                // Liquid renders the correct copy for the customer segment; JS only
                // gates by product category.
                note.hidden = false;
                note.style.removeProperty('display');
                note.setAttribute('aria-hidden', 'false');
            } else {
                // Force-hide outside Last Chance, even if experiment CSS uses !important.
                note.hidden = true;
                note.style.setProperty('display', 'none', 'important');
                note.setAttribute('aria-hidden', 'true');
            }
        });
    }

    switchToTab(category) {
        const tabs = this.querySelectorAll('.color-category-tab');
        const panels = this.querySelectorAll('.color-tab-panel');
        if (!tabs.length || !panels.length) return;

        tabs.forEach(tab => {
            const isTarget = tab.dataset.tabTarget === category;
            tab.classList.toggle('active', isTarget);
            tab.setAttribute('aria-selected', isTarget ? 'true' : 'false');
        });

        panels.forEach(panel => {
            panel.classList.toggle('active', panel.dataset.tabPanel === category);
        });
    }

    updateReviewsInfo(productData) {

        const judgeMeTitle = document.querySelector('.judge-me-title');
        if (judgeMeTitle) {
            judgeMeTitle.style.display = '';
            judgeMeTitle.setAttribute('data-product-id', productData.id);
        }


        const judgeMeWidgets = document.querySelectorAll('[data-product-id]');
        judgeMeWidgets.forEach(widget => {
            if (widget.hasAttribute('data-product-id')) {
                widget.setAttribute('data-product-id', productData.id);
            }
        });


        this.scheduleIdle(() => this.fetchAndUpdateReviewData(productData), 1200);

        // Reload Stamped.io badges
        const stampedRating = document.querySelector('stamped-rating');
        if (stampedRating) {
            stampedRating.setAttribute('data-id', productData.id);
            const variant = productData.selected_or_first_available_variant || productData.variants?.[0] || {};
            stampedRating.setAttribute('data-product-sku', variant.sku || '');
            stampedRating.setAttribute('data-product-title', productData.title);
        }

        if (typeof window.jdgm !== 'undefined' && window.jdgm.refresh) {
            setTimeout(() => {
                window.jdgm.refresh();
            }, 100);
        }
    }

    async fetchAndUpdateReviewData(productData) {
        try {
            const doc = await this.fetchProductPageDocument(productData?.url);
            if (doc) this.updateReviewsFromDocument(doc);
        } catch (error) {
            console.warn('Could not fetch review data:', error);

        }
    }

    /**
     * Fetches and parses a combined listing product page.
     * The document is cached for the current URL so that everything a single swatch click
     * needs from the server (reviews, upsell sliders) shares one request.
     */
    fetchProductPageDocument(url) {
        const productUrl = (url || '').split('?')[0];
        if (!productUrl) return Promise.resolve(null);

        if (this.productPageRequest?.url === productUrl) return this.productPageRequest.promise;

        const promise = fetch(productUrl, { credentials: 'same-origin' })
            .then((response) => {
                if (!response.ok) throw new Error(`Request for ${productUrl} failed with status ${response.status}`);
                return response.text();
            })
            .then((text) => new DOMParser().parseFromString(text, 'text/html'));

        // Don't cache failures, so the next swatch click can retry.
        promise.catch(() => {
            if (this.productPageRequest?.promise === promise) this.productPageRequest = null;
        });

        this.productPageRequest = { url: productUrl, promise };
        return promise;
    }

    /**
     * Re-renders the metafield-driven upsell sliders ("Finish the look") for the newly
     * selected color. Every color of a combined listing is its own product with its own
     * `custom.upsell` metafield, so the slides have to come from the server.
     */
    async updateUpsellSliders(productData) {
        // Only the PDP's own swatches may rewrite the page. Swatches inside a quick add
        // dialog belong to a different product (the modal is a <dialog class="quick-add-modal">).
        if (this.closest('dialog, quick-add-dialog, quick-add-component')) return;

        const newProductId = String(productData?.id || '');
        const sliders = Array.from(document.querySelectorAll('.pd-slider-block[data-source="metafield"]'));

        if (!newProductId || !productData?.url || !sliders.length) return;

        // Claim the slot before anything else: a response still in flight for a previously
        // clicked color is stale from here on, even when this click needs no request of its own.
        const requestId = (this.upsellRequestId = (this.upsellRequestId || 0) + 1);

        // `data-upsell-product-id`, not `data-product-id`: updateReviewsInfo() rewrites every
        // `[data-product-id]` on the page before this runs, which would hide the stale slider.
        if (sliders.every((slider) => slider.dataset.upsellProductId === newProductId)) return;

        sliders.forEach((slider) => slider.classList.add('pd-slider-block--updating'));

        try {
            const doc = await this.fetchProductPageDocument(productData.url);

            // A later swatch click owns the page now, so this response is stale.
            if (!doc || requestId !== this.upsellRequestId) return;

            const newSliders = Array.from(doc.querySelectorAll('.pd-slider-block[data-source="metafield"]'));

            sliders.forEach((slider, index) => {
                const blockId = slider.dataset.blockId;
                const newSlider =
                    newSliders.find((candidate) => candidate.dataset.blockId === blockId) || newSliders[index];

                if (!newSlider || !slider.isConnected) return;

                // importNode keeps the cached document intact for a repeat click on this color.
                slider.replaceWith(document.importNode(newSlider, true));
            });

            console.log('[ColorVariants] Upsell sliders updated', { productId: newProductId });
        } catch (error) {
            console.warn('[ColorVariants] Failed to update upsell sliders', error);
        } finally {
            sliders.forEach((slider) => slider.classList.remove('pd-slider-block--updating'));
        }
    }

    updateReviewsFromDocument(doc) {
        try {

            const judgeMeTitle = doc.querySelector('.judge-me-title');
            if (judgeMeTitle) {

                const currentJudgeMeTitle = document.querySelector('.judge-me-title');
                if (currentJudgeMeTitle) {

                    currentJudgeMeTitle.style.display = '';
                    currentJudgeMeTitle.outerHTML = judgeMeTitle.outerHTML;
                }
            }
        } catch (error) {
            console.warn('Error parsing review HTML:', error);

            const currentJudgeMeTitle = document.querySelector('.judge-me-title');
            if (currentJudgeMeTitle) {
                currentJudgeMeTitle.style.display = '';
            }
        }
    }

    updatePrice(variant) {
        // Simple price only (no discount handling yet)
        const priceText = this.formatPrice(variant.price);

        // Update primary price container if present
        const priceContainer = document.querySelector('.product__price');
        if (priceContainer) {
            const regular = priceContainer.querySelector('.price-item--regular');
            if (regular) regular.textContent = priceText;
            priceContainer.classList.remove('price--on-sale');
        }

        // Update simplified price elements
        const moneySpans = document.querySelectorAll('span.price span.money');
        moneySpans.forEach(el => {
            el.textContent = priceText;
        });
    }

    updateSKU(variant) {
        const skuElement = document.querySelector('.product__sku');
        if (skuElement) {
            if (variant.sku) {
                skuElement.textContent = variant.sku;
                skuElement.classList.remove('visibility-hidden');
            } else {
                skuElement.classList.add('visibility-hidden');
            }
        }
    }

    updateInventory(variant) {
        const inventoryElement = document.querySelector('.product__inventory');
        if (!inventoryElement || variant.inventory_management !== 'shopify') {
            if (inventoryElement) inventoryElement.classList.add('visibility-hidden');
            return;
        }

        inventoryElement.classList.remove('visibility-hidden');
        const svgWrapper = inventoryElement.querySelector('.svg-wrapper');

        const textNodes = Array.from(inventoryElement.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
        textNodes.forEach(node => node.remove());

        if (variant.inventory_quantity > 0) {
            if (variant.inventory_quantity <= 10) {
                if (svgWrapper) svgWrapper.style.color = 'rgb(238, 148, 65)';
                inventoryElement.appendChild(document.createTextNode(` ${variant.inventory_quantity} left in stock`));
            } else {
                if (svgWrapper) svgWrapper.style.color = 'rgb(62, 214, 96)';
                inventoryElement.appendChild(document.createTextNode(' In stock'));
            }
        } else {
            if (svgWrapper) svgWrapper.style.color = 'rgb(200, 200, 200)';
            inventoryElement.appendChild(document.createTextNode(' Out of stock'));
        }
    }

    updateAddToCartForm(variant) {
        setTimeout(() => {
            const productForms = document.querySelectorAll('form[action*="/cart/add"]');
            productForms.forEach(form => {
                const variantInput = form.querySelector('input[name="id"]');
                if (variantInput) {
                    variantInput.value = variant.id;
                }
            });
        }, 200);
    }

    updateVariantSelector(productData, preferredSelections = {}) {
        const variantSelector = document.querySelector('variant-selector');
        if (!variantSelector || productData.has_only_default_variant) return;

        const sectionId = this.getSectionId();
        const pickerType = variantSelector.getAttribute('data-picker-type');

        variantSelector.innerHTML = '';

        if (pickerType === 'dropdown') {
            this.createDropdownVariantPicker(variantSelector, productData, sectionId, preferredSelections);
        } else if (pickerType === 'button') {
            this.createButtonVariantPicker(variantSelector, productData, sectionId, preferredSelections);
        }


        const selectedVariant = this.getPreferredVariantForProduct(productData, preferredSelections);
        const script = document.createElement('script');
        script.type = 'application/json';
        script.setAttribute('data-selected-variant', '');
        script.textContent = JSON.stringify(selectedVariant);
        variantSelector.appendChild(script);


    }

    createDropdownVariantPicker(container, productData, sectionId, preferredSelections = {}) {
        const dropdownContainer = document.createElement('div');
        dropdownContainer.className = 'variant-block__dropdown';

        productData.options.forEach((option, optionIndex) => {
            // Skip Color options
            if (option.name === 'Color') return;
            // Skip options with only one value
            if (!option.values || option.values.length <= 1) return;

            const label = document.createElement('label');
            label.className = 'option__label';
            label.setAttribute('for', `Option-${sectionId}-${optionIndex}`);
            label.textContent = option.name;

            const fieldset = document.createElement('fieldset');
            fieldset.className = 'product-form__input';

            const select = document.createElement('select');
            select.name = `options[${option.name}]`;
            select.id = `Option-${sectionId}-${optionIndex}`;
            select.setAttribute('form', `product-form-${sectionId}`);

            const optionName = String(option.name || '').toLowerCase();
            const preferredValue = preferredSelections[optionName];
            const preferredExists = preferredValue && this.productHasOptionValue(productData, optionName, preferredValue);
            const fallbackValue = option.values.find(value => value.available !== false)?.value ?? option.values[0]?.value;

            option.values.forEach((value, valueIndex) => {
                const optionElement = document.createElement('option');
                optionElement.id = `${sectionId}-${option.position}-${valueIndex}`;
                optionElement.value = value.value;
                optionElement.textContent = value.value;

                if ((preferredExists && value.value === preferredValue) || (!preferredExists && value.value === fallbackValue)) {
                    optionElement.selected = true;
                }

                select.appendChild(optionElement);
            });

            fieldset.appendChild(select);
            dropdownContainer.appendChild(label);
            dropdownContainer.appendChild(fieldset);
        });

        container.appendChild(dropdownContainer);
    }

    createButtonVariantPicker(container, productData, sectionId, preferredSelections = {}) {
        const isInQuickAddModal = this.closest('quick-add-modal');

        if (isInQuickAddModal) {
            const sizeValues = new Set();

            productData.variants.forEach(variant => {
                if (variant.option1 && variant.option1 !== 'Default Title') {
                    sizeValues.add(variant.option1);
                }
            });

            if (sizeValues.size <= 1) return;

            const buttonContainer = document.createElement('div');
            buttonContainer.className = 'variant-select__button';

            const fieldset = document.createElement('fieldset');
            fieldset.className = 'product-form__input';

            const legend = document.createElement('legend');
            legend.className = 'option__label';
            legend.textContent = 'Size';
            fieldset.appendChild(legend);

            const valuesArray = Array.from(sizeValues);
            const preferredSize = preferredSelections.size;
            const preferredVariant = preferredSize
                ? productData.variants.find(variant => variant.option1 === preferredSize && variant.available)
                : null;
            const fallbackVariant = productData.variants.find(variant => variant.available) || productData.variants[0];

            valuesArray.forEach((value, valueIndex) => {
                const matchingVariant = productData.variants.find(variant => variant.option1 === value);
                const isAvailable = matchingVariant ? matchingVariant.available : true;

                const input = document.createElement('input');
                input.type = 'radio';
                input.id = `${sectionId}-1-${valueIndex}`;
                input.name = 'Size-1';
                input.setAttribute('form', `product-form-${sectionId}`);
                input.value = value;
                input.className = isAvailable ? 'pill-radio' : 'pill-radio disabled';
                input.setAttribute('data-product-url', '');

                if (matchingVariant && matchingVariant.id) {
                    input.setAttribute('data-option-value-id', matchingVariant.id);
                }

                if (!isAvailable) {
                    input.disabled = true;
                }
                if ((preferredVariant && preferredVariant.option1 === value) || (!preferredVariant && fallbackVariant && fallbackVariant.option1 === value)) {
                    input.checked = true;
                }

                const label = document.createElement('label');
                label.className = isAvailable ? 'pill-label' : 'pill-label pill-disabled';
                label.setAttribute('for', input.id);
                label.textContent = value;

                fieldset.appendChild(input);
                fieldset.appendChild(label);
            });

            buttonContainer.appendChild(fieldset);
            container.appendChild(buttonContainer);

        } else {
            const buttonContainer = document.createElement('div');
            buttonContainer.className = 'variant-select__button';

            productData.options.forEach((option, optionIndex) => {
                // Skip Color options
                if (option.name === 'Color') return;
                // Skip options with only one value
                if (!option.values || option.values.length <= 1) return;

                const fieldset = document.createElement('fieldset');
                fieldset.className = 'product-form__input';

                const legend = document.createElement('legend');
                legend.className = 'option__label';
                legend.textContent = option.name;
                fieldset.appendChild(legend);

                const optionName = String(option.name || '').toLowerCase();
                const preferredValue = preferredSelections[optionName];
                const preferredExists = preferredValue && this.productHasOptionValue(productData, optionName, preferredValue);
                const fallbackValue = option.values.find(value => value.available !== false)?.value ?? option.values[0]?.value;

                option.values.forEach((value, valueIndex) => {
                    const input = document.createElement('input');
                    input.type = 'radio';
                    input.id = `${sectionId}-${option.position}-${valueIndex}`;
                    input.name = `${option.name}-${option.position}`;
                    input.setAttribute('form', `product-form-${sectionId}`);
                    input.value = value.value;
                    input.className = 'pill-radio';

                    if ((preferredExists && value.value === preferredValue) || (!preferredExists && value.value === fallbackValue)) {
                        input.checked = true;
                    }

                    const label = document.createElement('label');
                    label.className = 'pill-label';
                    label.setAttribute('for', input.id);
                    label.textContent = value.value;

                    fieldset.appendChild(input);
                    fieldset.appendChild(label);
                });

                buttonContainer.appendChild(fieldset);
            });

            container.appendChild(buttonContainer);
        }
    }

    updatePageInfo(productData, preferredSelections = {}) {
        const isInQuickAddModal = this.closest('quick-add-modal');

        console.log('[ColorVariants] updatePageInfo called', {
            productTitle: productData.title,
            productUrl: productData.url,
            isInModal: isInQuickAddModal
        });

        if (!isInQuickAddModal) {
            if (productData.url && window.history && window.history.replaceState) {
                const preferredVariant = this.getPreferredVariantForProduct(productData, preferredSelections);
                const urlWithVariant = preferredVariant ?
                    `${productData.url}?variant=${preferredVariant.id}` :
                    productData.url;

                console.log('[ColorVariants] Updating URL to:', urlWithVariant);
                window.history.replaceState({}, '', urlWithVariant);

                const productInfo = document.querySelector('product-info');
                if (productInfo) {
                    productInfo.setAttribute('data-url', productData.url);
                }
            }

            if (productData.title) {
                console.log('[ColorVariants] Updating page title to:', productData.title);
                document.title = productData.title;
            }
        }
    }

    formatPrice(priceInCents) {
        const cents = Math.round(Number(priceInCents));
        if (!Number.isFinite(cents)) return '';

        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
            maximumFractionDigits: 2
        }).format(cents / 100);
    }


    recreateZoomIcon() {
        if (!this.mediaGallery) return;
        const originalZoomIcon = this.mediaGallery.querySelector('.product__media-icon');
        if (!originalZoomIcon) return;

        const existingZoomIcon = this.mediaGallery.querySelector('.product__media-icon');
        if (existingZoomIcon) {
            existingZoomIcon.remove();
        }

        const newZoomIcon = originalZoomIcon.cloneNode(true);
        const container = this.mediaGallery;
        container.appendChild(newZoomIcon);

        setTimeout(() => {
            this.reinitializeLightbox();
        }, 50);
    }

    updateModalContent(productData) {
        // Try to find zoom dialog by different methods
        let modal = null;
        const sectionId = this.getSectionId();

        // Method 1: Try with section ID
        modal = document.querySelector(`#zoom-dialog-${sectionId}`);

        // Method 2: Try to find any zoom dialog on the page
        if (!modal) {
            modal = document.querySelector('[id^="zoom-dialog-"]');
        }

        // Method 3: Look for zoom dialog within the current section
        if (!modal && sectionId) {
            const section = document.querySelector(`[data-section="${sectionId}"]`);
            if (section) {
                modal = section.querySelector('[id^="zoom-dialog-"]');
            }
        }

        console.log('[ColorVariants] Looking for zoom dialog', {
            sectionId,
            modalFound: !!modal,
            modalId: modal?.id || 'none'
        });

        if (!modal) {
            console.warn('[ColorVariants] Zoom dialog not found');
            return;
        }
        if (!productData.media) {
            console.warn('[ColorVariants] No media for modal update');
            return;
        }

        const modalContent = modal.querySelector('.dialog-zoomed-gallery');
        if (!modalContent) {
            console.warn('[ColorVariants] .dialog-zoomed-gallery not found in modal');
            return;
        }

        console.log('[ColorVariants] Updating zoom dialog content with media count', productData.media.length);

        // Clear existing modal content
        modalContent.innerHTML = '';

        // Add each media item to the zoom dialog with proper structure
        productData.media.forEach((media, index) => {
            this.createZoomDialogMediaElement(media, modalContent, index + 1);
        });

        // Update zoom dialog thumbnails
        this.updateZoomDialogThumbnails(modal, productData);

        // Force zoom dialog to re-initialize its media references
        this.reinitializeZoomDialog(modal);
    }

    createZoomDialogMediaElement(media, container, mediaIndex) {
        // Create the li wrapper that matches zoom dialog structure
        const li = document.createElement('li');
        li.id = `product-${media.id}-${mediaIndex}`;
        li.className = `
            product-media-container
            product-media-container--${media.media_type}
            constrain-height
            media-fit
            ${media.media_type === 'image' ? 'product-media-container--zoomable' : ''}
        `.trim().replace(/\s+/g, ' ');

        // Set aspect ratio style if needed
        const aspectRatio = media.preview_image?.aspect_ratio || 1.0;
        li.style.cssText = `--media-preview-ratio: ${aspectRatio};`;

        // Add click handler for images to close dialog
        if (media.media_type === 'image') {
            li.setAttribute('on:click', '/close');
        }

        if (media.media_type === 'image') {
            // Create drag-zoom-wrapper for images
            const dragZoomWrapper = document.createElement('drag-zoom-wrapper');
            dragZoomWrapper.className = 'product-media__drag-zoom-wrapper';

            // Create product-media container
            const productMedia = document.createElement('div');
            productMedia.className = 'product-media';

            const img = document.createElement('img');
            img.className = 'product-media__image';
            img.src = media.src || media.preview_image?.src;
            img.alt = media.alt || '';
            img.setAttribute('data-media-id', media.id);
            img.loading = 'eager';

            // Generate srcset for high-resolution images
            try {
                const baseSrc = (media.src || media.preview_image?.src || '').split('?')[0];
                const srcsetSizes = [352, 832, 1200, media.width || 1223];
                const srcset = srcsetSizes.map(width =>
                    `${baseSrc}?width=${width} ${width}w`
                ).join(', ');
                img.setAttribute('srcset', srcset);
                img.setAttribute('sizes', '100vw');
            } catch (e) {
                console.warn('[ColorVariants] Failed to build srcset for zoom dialog media', e);
            }

            productMedia.appendChild(img);
            dragZoomWrapper.appendChild(productMedia);
            li.appendChild(dragZoomWrapper);

        } else if (media.media_type === 'video') {
            // Create product-media container for video
            const productMedia = document.createElement('div');
            productMedia.className = 'product-media';

            const video = document.createElement('video');
            video.setAttribute('playsinline', 'true');
            video.setAttribute('controls', 'controls');
            video.setAttribute('autoplay', 'autoplay');
            video.setAttribute('loop', 'loop');
            video.setAttribute('preload', 'none');
            video.setAttribute('muted', 'muted');
            video.setAttribute('data-media-id', media.id);

            if (media.alt) {
                video.setAttribute('aria-label', media.alt);
            }

            if (media.preview_image?.src) {
                video.setAttribute('poster', media.preview_image.src);
            }

            // Add source element
            if (media.sources && media.sources.length > 0) {
                const source = document.createElement('source');
                source.src = media.sources[0].url;
                source.type = media.sources[0].mime_type || 'video/mp4';
                video.appendChild(source);
            }

            // Add fallback image
            if (media.preview_image?.src) {
                const fallbackImg = document.createElement('img');
                fallbackImg.src = media.preview_image.src;
                fallbackImg.alt = media.alt || '';
                video.appendChild(fallbackImg);
            }

            productMedia.appendChild(video);
            li.appendChild(productMedia);

        } else {
            // Handle other media types
            const productMedia = document.createElement('div');
            productMedia.className = 'product-media';

            const img = document.createElement('img');
            img.className = 'product-media__image';
            img.src = media.preview_image?.src || media.src;
            img.alt = media.alt || '';
            img.setAttribute('data-media-id', media.id);
            img.loading = 'eager';

            productMedia.appendChild(img);
            li.appendChild(productMedia);
        }

        container.appendChild(li);
    }

    updateZoomDialogThumbnails(modal, productData) {
        const thumbnailsList = modal.querySelector('.dialog-thumbnails-list');
        if (!thumbnailsList || productData.media.length <= 1) return;

        // Clear existing thumbnails
        thumbnailsList.innerHTML = '';

        // Create new thumbnails for each media item
        productData.media.forEach((media, index) => {
            const thumbnailButton = document.createElement('button');
            thumbnailButton.type = 'button';
            thumbnailButton.className = 'button button-unstyled dialog-thumbnails-list__thumbnail';
            thumbnailButton.setAttribute('aria-label', `Scroll to ${media.alt || media.media_type}`);

            // Set aspect ratio style
            const aspectRatio = media.preview_image?.aspect_ratio || 1.0;
            thumbnailButton.style.cssText = `--aspect-ratio: ${aspectRatio}; --gallery-aspect-ratio: ${aspectRatio};`;

            // Set first thumbnail as selected
            if (index === 0) {
                thumbnailButton.setAttribute('aria-selected', 'true');
            }

            // Add event listeners directly
            thumbnailButton.addEventListener('click', () => {
                this.handleZoomThumbnailClick(index, modal);
            });

            thumbnailButton.addEventListener('pointerenter', () => {
                this.handleZoomThumbnailHover(index, modal);
            });

            // Create thumbnail image
            const img = document.createElement('img');
            let imageUrl = media.preview_image?.src || media.src;

            // Try to get a smaller version for thumbnails
            if (imageUrl && !imageUrl.includes('width=')) {
                const baseSrc = imageUrl.split('?')[0];
                imageUrl = `${baseSrc}?width=160`;
            }

            img.src = imageUrl;
            img.alt = media.alt || '';
            img.loading = 'lazy';
            img.setAttribute('sizes', 'auto, 110, (min-width: 750px) 160');

            // Generate srcset for responsive thumbnails
            try {
                const baseSrc = (media.preview_image?.src || media.src || '').split('?')[0];
                const widths = [300, 375, 450, 525, 600, 675, 750, 768, 850, 900, 1024];
                const srcset = widths.map(w => `${baseSrc}?width=${w} ${w}w`).join(', ');
                img.setAttribute('srcset', srcset);
            } catch (e) {
                console.warn('[ColorVariants] Failed to build thumbnail srcset', e);
            }

            thumbnailButton.appendChild(img);
            thumbnailsList.appendChild(thumbnailButton);
        });
    }

    reinitializeZoomDialog(modal) {
        // Force the zoom dialog component to re-scan for media elements
        const zoomDialogComponent = modal;
        if (zoomDialogComponent && typeof zoomDialogComponent.connectedCallback === 'function') {
            try {
                // Force re-initialization of refs
                zoomDialogComponent.disconnectedCallback?.();
                zoomDialogComponent.connectedCallback();
                console.log('[ColorVariants] Zoom dialog re-initialized');
            } catch (error) {
                console.warn('[ColorVariants] Error re-initializing zoom dialog:', error);
            }
        }

        // Also trigger a manual refresh of media references
        setTimeout(() => {
            const mediaElements = modal.querySelectorAll('.dialog-zoomed-gallery .product-media-container');
            const thumbnailElements = modal.querySelectorAll('.dialog-thumbnails-list button');
            console.log('[ColorVariants] Found media elements after update:', {
                mediaCount: mediaElements.length,
                thumbnailCount: thumbnailElements.length
            });
        }, 100);
    }

    handleZoomThumbnailClick(index, modal) {
        const mediaElements = modal.querySelectorAll('.dialog-zoomed-gallery .product-media-container');
        const thumbnails = modal.querySelectorAll('.dialog-thumbnails-list button');

        if (mediaElements[index]) {
            // Scroll to the corresponding media element
            mediaElements[index].scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            // Update thumbnail selection
            thumbnails.forEach((thumb, i) => {
                thumb.setAttribute('aria-selected', i === index ? 'true' : 'false');
            });
        }
    }

    handleZoomThumbnailHover(index, modal) {
        // Optional: Could preload high-res images here
        console.log('[ColorVariants] Thumbnail hover for index', index);
    }

    reinitializeLightbox() {
        const triggers = document.querySelectorAll('.media-gallery__grid .light-box-zoom-trigger');
        if (!triggers.length) return;

        triggers.forEach((trigger) => {
            const newTrigger = trigger.cloneNode(true);
            if (trigger.parentNode) {
                trigger.parentNode.replaceChild(newTrigger, trigger);
            }
            newTrigger.addEventListener('click', () => {
                const target = newTrigger.getAttribute('data-modal');
                const modal = target ? document.querySelector(target) : null;
                if (modal && typeof modal.showModal === 'function') modal.showModal(newTrigger);
            });
        });
    }

    initThumbnails() {
        const thumbnails = this.mediaGallery?.querySelectorAll('.thumbnail-item');
        if (!thumbnails) return;

        thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
                if (this.swiper) {
                    this.swiper.slideTo(index);
                }
                this.updateThumbnailActive(index);
            });
        });

        if (thumbnails.length > 0) {
            this.updateThumbnailActive(0);
        }
    }

    updateThumbnailActive(activeIndex = 0) {
        const thumbnails = this.mediaGallery?.querySelectorAll('.thumbnail-item');
        if (!thumbnails) return;

        thumbnails.forEach((thumbnail, index) => {
            thumbnail.classList.toggle('active', index === activeIndex);
        });
    }

    clickFirstVariant(variantSelector, productData, preferredSelections = {}) {
        const pickerType = variantSelector.getAttribute('data-picker-type');
        const preferredVariant = this.getPreferredVariantForProduct(productData, preferredSelections);

        if (pickerType === 'dropdown') {
            const firstSelect = variantSelector.querySelector('select');
            if (firstSelect && firstSelect.options.length > 0) {
                const optionName = firstSelect.name.replace(/^options\[/, '').replace(/\]$/, '').toLowerCase();
                const preferredValue = preferredSelections[optionName];
                const preferredIndex = preferredValue
                    ? Array.from(firstSelect.options).findIndex(option => option.value === preferredValue && !option.disabled)
                    : -1;
                const fallbackIndex = Array.from(firstSelect.options).findIndex(option => !option.disabled);
                const targetIndex = preferredIndex >= 0 ? preferredIndex : fallbackIndex;

                if (targetIndex >= 0) {
                    firstSelect.selectedIndex = targetIndex;
                    firstSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        } else if (pickerType === 'button') {
            const radioInputs = variantSelector.querySelectorAll('input[type="radio"]');
            let targetRadio = null;

            if (preferredVariant?.option1) {
                targetRadio = Array.from(radioInputs).find((radio) => {
                    return radio.value === preferredVariant.option1 && !radio.classList.contains('disabled') && !radio.disabled;
                });
            }

            if (!targetRadio) {
                for (const radio of radioInputs) {
                    if (!radio.classList.contains('disabled') && !radio.disabled) {
                        targetRadio = radio;
                        break;
                    }
                }
            }

            if (targetRadio) {
                targetRadio.checked = true;
                targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    getCurrentNonColorSelections() {
        const selections = {};
        const picker = document.querySelector('variant-picker');
        if (!picker) return selections;

        if (typeof picker.getStickySelections === 'function') {
            Object.assign(selections, picker.getStickySelections() || {});
        }

        picker.querySelectorAll('.variant-option').forEach((option) => {
            const optionName = (option.getAttribute('data-option-name') || '').toLowerCase();
            if (!optionName || optionName.includes('color')) return;

            const checkedInput = option.querySelector('input:checked');
            if (checkedInput instanceof HTMLInputElement) {
                selections[optionName] = checkedInput.value;
                return;
            }

            const select = option.querySelector('select');
            if (select instanceof HTMLSelectElement) {
                selections[optionName] = select.value;
            }
        });

        return selections;
    }

    getPreferredVariantForProduct(productData, preferredSelections = {}) {
        if (!productData) return null;

        const variants = Array.isArray(productData.variants) ? productData.variants : [];
        const options = Array.isArray(productData.options) ? productData.options : [];

        const matchesPreferred = (variant, isMatchedOption) => {
            return options.every((option) => {
                const optionName = String(option?.name || '').toLowerCase();
                if (!optionName || optionName.includes('color') || !isMatchedOption(optionName)) return true;

                const preferredValue = preferredSelections[optionName];
                if (!preferredValue) return true;

                return String(variant[`option${option.position}`] || '') === String(preferredValue);
            });
        };
        const matchesAll = () => true;
        const matchesSize = (optionName) => optionName.includes('size');

        // Keep the shopper's size across colors even when it is sold out in the new color: the PDP
        // lets sold-out sizes be selected (Notify Me), so falling back to another size would
        // silently replace a choice they made. Other options relax before size does.
        const matchingVariant =
            variants.find((variant) => variant?.available && matchesPreferred(variant, matchesAll)) ||
            variants.find((variant) => matchesPreferred(variant, matchesAll)) ||
            variants.find((variant) => variant?.available && matchesPreferred(variant, matchesSize)) ||
            variants.find((variant) => matchesPreferred(variant, matchesSize));

        if (matchingVariant) return matchingVariant;

        return (
            (productData.selected_variant_id &&
                variants.find((variant) => String(variant.id) === String(productData.selected_variant_id) && variant.available)) ||
            variants.find((variant) => variant.available) ||
            variants.find((variant) => String(variant.id) === String(productData.selected_variant_id)) ||
            variants[0] ||
            null
        );
    }

    getVariantSelectionKey(variant) {
        if (!variant) return null;

        return [variant.option1, variant.option2, variant.option3].filter(Boolean).join('~~~') || null;
    }

    productHasOptionValue(productData, optionName, optionValue) {
        if (!productData || !optionName || !optionValue) return false;

        const option = (productData.options || []).find((entry) => {
            return String(entry?.name || '').toLowerCase() === String(optionName).toLowerCase();
        });
        if (!option?.position) return false;

        return (productData.variants || []).some((variant) => {
            return variant.available && String(variant[`option${option.position}`] || '') === String(optionValue);
        });
    }

    hideVariantSelectorTemporarily() {
        const variantSelector = document.querySelector('variant-selector');
        if (!variantSelector) return;

        variantSelector.style.opacity = '0';

        setTimeout(() => {
            variantSelector.style.opacity = '';
        }, 1000);
    }
}

customElements.define('color-variants', ColorVariants);